import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=79ddd8aa&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ddd8aa')) {
      api.createRecord('79ddd8aa', component.options)
    } else {
      api.reload('79ddd8aa', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=79ddd8aa&", function () {
      api.rerender('79ddd8aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rpRBnaeS0D7f/JS/pricehelp.vue"
export default component.exports